/*
  Project: Dreamstage
  Author: Marcin Ziółek
 */

import videos from './modules/videos';
import menu from './modules/menu';
import carousel from './modules/carousel';
import collapseElem from './modules/collapse';
import hero from './modules/hero';
import header from './modules/header';
import sorting from './modules/sorting';

videos();
menu();
carousel();
collapseElem();
hero();
header();
sorting();



// WEBPACK FOOTER //
// ./src/scripts/app.js